import {ColorCodesEnum, ComponentTypesEnum} from '../../app/shared/enums/common';
import {CheckboxControl} from 'appShared/classes/controls';

export const ClientManagerialRightsFormArraySelector = 'managerialRightsFormArray';
export const ClientCashOperationsRightsFormArraySelector = 'cashOperationsFormArray';
export const ClientReportsRightsFormArraySelector = 'reportsRightsFormArray';
export const ClientsMdsRightsFormArraySelector = 'mdsFormArray';
export const ClientsUsersRightsFormArraySelector = 'usersRightsFormArray';
export const ClientsCurrencyExchangeRightsFormArraySelector = 'currencyExchangeRightsFormArray';
export const ClientsFundPortalRightsFormArraySelector = 'fundPortalRightsFormArray';

export const ClientRightEditPermissionCheckbox = (
    index: string,
    controlName: string,
    controlValue: number,
    isChecked: boolean
): CheckboxControl => {
    return new CheckboxControl({
        name: index,
        value: !controlValue ? null : controlValue,
        placeholder: controlName,
        validators: [],
        componentType: ComponentTypesEnum.Checkbox,
        color: ColorCodesEnum.Primary,
        checked: isChecked,
        expectBooleanValue: false,
        disabled: true
    });
};
